var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.933 2L3 9.285L6.308 36.408L23.955 46L41.693 36.278L45 9.156L23.933 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.818 10.527L24 4.13501V43.695L39.832 35.017L42.818 10.527Z",
    fill: "#161631"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.941 4.11499L5.181 10.644L8.168 35.143L23.951 43.721L24 43.695V4.13499L23.941 4.11499Z",
    fill: "#161631"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.996V15.504L32.578 34H36.987L24 5.996Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.013 34H15.422L24 15.504V5.996L11.013 34Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H30V28H24V24Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H24V28H18V24Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.eb7dd74ab20ad3f7e149b79497537644.svg";
export { ForwardRef as ReactComponent };